import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import { Phase } from "../../features/projects/types";

interface SegmentedProgressBarProps {
    phases: Phase[];
    progressPercentage: number;
    status: "green" | "red" | "amber";
}

function LinearProgressWithLabel(props: LinearProgressProps & { value: number, status: "green" | "red" | "amber" }) {
    return (
        <LinearProgress
            variant="determinate"
            {...props}
            sx={{
                height: 10,
                borderRadius: 5,
                [`& .MuiLinearProgress-bar`]: {
                    borderRadius: 5,
                    backgroundColor:
                        props.status === 'green' ? 'success.main' :
                            props.status === 'amber' ? 'warning.main' :
                                'error.main'
                },
                backgroundColor: "divider",
            }}
        />
    );
}

export const SegmentedProgressBar: React.FC<SegmentedProgressBarProps> = ({ phases, progressPercentage, status }) => {
    return (
        <Box display="flex" alignItems="center" gap={1} width={'100%'}>
            <Box display="flex" gap={0.5} width={'85%'}>
                {
                    phases.length === 0 ?
                        <Typography variant="caption" color="text.secondary">Schedule to be defined</Typography>
                        :
                        phases.map((phase, i) => (
                            <Tooltip title={`${phase.name}: ${phase.percentage_complete}%`} arrow key={i} placement="top">
                                <Box
                                    key={i}
                                    sx={{
                                        width: '20%',
                                    }}
                                >
                                    <LinearProgressWithLabel value={phase.percentage_complete} status={status} />
                                </Box>
                            </Tooltip>
                        ))
                }
            </Box>
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{ minWidth: '15%', textAlign: "right" }}
            >
                {progressPercentage.toFixed(1)}%
            </Typography>
        </Box>
    );
};